module.exports = __webpack_public_path__ + "static/media/feedback_founders.a1aad164.jpg";